
interface TableData {
  headers: {
    text: string;
    align?: string;
    sortable: boolean;
    value: string;
    class?: string;
    width?: string;
  }[];
}
import Currency from '@/Models/PrimitiveModels/Currency/Currency';
import StripeSubscriptionService from '@/Services/Subscription/StripeSubscriptionService';
import type { Invoice } from '@/classes/stripe';
import Alert from '@/components/Alert.vue';
import Icon from '@/components/Icons/Icon.vue';
import store from '@/store';
import dayjs from 'dayjs';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Icon,
    Alert,
  },
})
export default class Invoices extends Vue {
  dayjs = dayjs;
  activePlan = store.state?.subscription?.activePlan || {};
  stripeSubscriptionService = new StripeSubscriptionService();

  async mounted(): Promise<void> {
    this.fetchInvoices();
  }

  async fetchInvoices(): Promise<void> {
    store.dispatch('account/loadInvoices');
  }

  get invoices(): Invoice[] {
    return this.$store.state?.account.invoices || [];
  }

  get isInvoicesLoading(): boolean {
    return this.$store.state?.account.loading;
  }

  get historyTableData(): TableData {
    return {
      headers: [
        {
          text: this.$t('fields.account.billing.transactions.header_status').toString(),
          align: 'start',
          sortable: false,
          value: 'status',
          class: 'qr-data-table__header',
          width: 'auto',
        },
        {
          text: this.$t('fields.account.billing.transactions.header_invoice_nr').toString(),
          align: 'start',
          sortable: false,
          value: 'number',
          class: 'qr-data-table__header',
        },
        {
          text: this.$t('fields.account.billing.transactions.header_plan').toString(),
          align: 'start',
          sortable: false,
          value: 'plan',
          class: 'qr-data-table__header',
        },
        {
          text: this.$t('fields.account.billing.transactions.header_date').toString(),
          align: 'start',
          sortable: false,
          value: 'date',
          class: 'qr-data-table__header',
        },
        {
          text: this.$t('fields.account.billing.transactions.header_total').toString(),
          align: 'start',
          sortable: false,
          value: 'total',
          class: 'qr-data-table__header',
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
        },
      ],
    };
  }

  getHistoryRowClass(status: string, originalStatus: string): { [key: string]: boolean } {
    let classPrefix = 'qr-data-table__payment--status';
    return {
      [`${classPrefix}--paid`]: status === 'paid',
      [`${classPrefix}--not-paid`]: status === 'not_paid',
      [`${classPrefix}--refunded`]: status === 'refunded',
      [`${classPrefix}--pending`]: status === 'pending',
      [`${classPrefix}--pending`]: originalStatus === 'void',
    };
  }

  getStatusName(status: string, originalStatus: string): string {
    if (originalStatus === 'void') {
      return this.$t('fields.account.billing.transactions.status_void').toString();
    }

    switch (status) {
      case 'paid':
        return this.$t('fields.account.billing.transactions.status_paid').toString();
      case 'not_paid':
        return this.$t('fields.account.billing.transactions.status_not_paid').toString();
      case 'refunded':
        return this.$t('fields.account.billing.transactions.status_refunded').toString();
      case 'pending':
        return this.$t('fields.account.billing.transactions.status_pending').toString();
      default:
        return '';
    }
  }

  formatInvoiceTotal(price: number): string {
    const formatPrice = price / 100;
    const currencyModel = new Currency();
    currencyModel.price = formatPrice;
    return currencyModel.displayPrice({ price: currencyModel.price, useGrouping: true });
  }
}
